// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Reset/base scoped al contenedor raíz de V2 (.root).
 * Va como CSS Module para no filtrarse a nada externo, aunque V2
 * ya se carga por import() dinámico y no comparte bundle con V1.
 */
.base_root__4VSic {
  min-height: 100vh;
  font-family: var(--font-sans);
  color: var(--dylo-text);
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
}

.base_root__4VSic *,
.base_root__4VSic *::before,
.base_root__4VSic *::after {
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/v2/styles/base.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,uBAAuB;EACvB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;EAGE,sBAAsB;AACxB","sourcesContent":["/*\n * Reset/base scoped al contenedor raíz de V2 (.root).\n * Va como CSS Module para no filtrarse a nada externo, aunque V2\n * ya se carga por import() dinámico y no comparte bundle con V1.\n */\n.root {\n  min-height: 100vh;\n  font-family: var(--font-sans);\n  color: var(--dylo-text);\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n}\n\n.root *,\n.root *::before,\n.root *::after {\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `base_root__4VSic`
};
export default ___CSS_LOADER_EXPORT___;
